import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { DatePicker } from "antd";
import { Button, Col, Form, Input, Row, Card, Typography } from "antd";
import { FC, useEffect, useState } from "react";

const { Title, Text } = Typography;
const { TextArea } = Input;

interface Props {
  enhancementProcedure: any;
  form: any;
  isProcedureSubmitted?: boolean;
}

const NewExtensionOfStayFormEchs: FC<Props> = ({
  enhancementProcedure,
  form,
  isProcedureSubmitted,
}) => {
  const [totalProcedureAmount, setTotalProcedureAmount] = useState(0);

  const items = Form.useWatch("items", form);

  useEffect(() => {
    if (enhancementProcedure?.length) {
      form.setFieldsValue({ items: enhancementProcedure });
    }
  }, [enhancementProcedure]);

  useEffect(() => {
    const calculateTotal = (data: any[]) => {
      return data?.reduce((sum: number, procedure: any) => {
        const amount = parseFloat(procedure?.cost || "0");
        return sum + (isNaN(amount) ? 0 : amount);
      }, 0);
    };

    let total = 0;

    if (Array.isArray(items) && items.length > 0) {
      total += calculateTotal(items);
    }

    setTotalProcedureAmount(total);
  }, [form, items]);

  return (
    <Card
      title="Procedure Entries"
      style={{ borderRadius: 12 }}
      bodyStyle={{ padding: "0px 16px" }}
    >
      <div
        style={{ padding: "2px 14px", overflow: "auto" }}
        className="enhancement-procedures-modal"
      >
        <Form
          form={form}
          labelAlign="left"
          labelWrap
          labelCol={{
            xs: { span: 24 },
            sm: { span: 12 },
            md: { span: 8 },
            lg: { span: 6 },
          }}
          wrapperCol={{
            xs: { span: 24 },
            sm: { span: 12 },
            md: { span: 16 },
            lg: { span: 18 },
          }}
          style={{ width: "100%" }}
        >
          <Row
            gutter={[16, 16]}
            align="top"
            style={{
              border: "1px solid #C4C4C4",
              padding: "10px 20px",
              borderRadius: "16px",
              marginBottom: "0.8rem",
            }}
          >
            <Col span={12}>
              <Form.Item
                label="Range of Stay Extension"
                name={"rangeOfStayExtension"}
                rules={[
                  { required: true, message: "Required" },
                  {
                    pattern: /^\d{1,10}-\d{1,10}$/,
                    message: "Only numbers allowed (1–10 digits)",
                  },
                ]}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                style={{ display: "flex", flexDirection: "column" }}
              >
                <Input
                  style={{ borderRadius: "5px" }}
                  placeholder="Enter Diagnosis"
                  disabled={isProcedureSubmitted}
                />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                label="Proposed New Date of Discharge"
                name={"proposedNewDateOfDischarge"}
                rules={[{ required: true, message: "Required" }]}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                style={{ display: "flex", flexDirection: "column" }}
              >
                <DatePicker
                  style={{ width: "100%", borderRadius: "5px" }}
                  placeholder="Select Date"
                  format="DD-MM-YYYY"
                  disabled={isProcedureSubmitted}
                />
              </Form.Item>
            </Col>

            <Col span={24}>
              <Form.Item
                label="Diagnosis"
                name={"diagnosis"}
                rules={[{ required: true, message: "Required" }]}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                style={{ display: "flex", flexDirection: "column" }}
              >
                <Input.TextArea
                  style={{ borderRadius: "5px" }}
                  placeholder="Enter Diagnosis"
                  disabled={isProcedureSubmitted}
                />
              </Form.Item>
            </Col>

            <Col span={24}>
              <Form.Item
                label="Remarks"
                name={"remark"}
                rules={[{ required: true, message: "Required" }]}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                style={{ display: "flex", flexDirection: "column" }}
              >
                <Input.TextArea
                  style={{ borderRadius: "5px" }}
                  placeholder="Enter Diagnosis"
                  disabled={isProcedureSubmitted}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    </Card>
  );
};

export default NewExtensionOfStayFormEchs;
